import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import InputField from '../../Reusable/InputField';

const ThirdSection = (props) => {
  const { onChange, state, errors, errorsHandler } = props || {};

  return (
    <Card>
      <Card.Header className="primary-header-card">
        <Card.Title className="d-flex gap-3 align-items-center">
          Kontakt podaci
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={4}>
            <div className="title-block-form">Adresa prebivališta</div>
            <InputField
              id="street"
              name="street"
              placeholder={'Ulica'}
              onChange={onChange}
              value={state.street}
            />
            <InputField
              id="place"
              name="place"
              placeholder={'Mesto'}
              onChange={onChange}
              value={state.place}
            />
            <InputField
              id="postalCode"
              name="postalCode"
              placeholder={'Poštanski broj'}
              onChange={onChange}
              value={state.postalCode}
            />
            <InputField
              id="postalAddressCode"
              name="postalAddressCode"
              placeholder={'Poštanski adresni kod'}
              onChange={onChange}
              value={state.postalAddressCode}
            />
            <InputField
              id="municipality"
              name="municipality"
              placeholder={'Opština'}
              onChange={onChange}
              value={state.municipality}
            />
            <InputField
              id="taxNumber"
              name="taxNumber"
              placeholder={'Poreski broj opštine'}
              onChange={onChange}
              value={state.taxNumber}
            />
            <InputField
              id="country"
              name="country"
              placeholder={'Zemlja'}
              onChange={onChange}
              value={state.country}
            />
          </Col>
          <Col md={4}>
            <div className="title-block-form">Adresa primanja pošte</div>
            <InputField
              id="postalStreet"
              name="postalStreet"
              placeholder={'Ulica'}
              onChange={onChange}
              value={state.postalStreet}
            />
            <InputField
              id="postalAddress"
              name="postalAddress"
              placeholder={'Mesto'}
              onChange={onChange}
              value={state.postalAddress}
            />
            <InputField
              id="postalNumber"
              name="postalNumber"
              placeholder={'Poštanski broj'}
              onChange={onChange}
              value={state.postalNumber}
            />
            <InputField
              id="postalReceiptAddressCode"
              name="postalReceiptAddressCode"
              placeholder={'Poštanski adresni kod'}
              onChange={onChange}
              value={state.postalReceiptAddressCode}
            />
            <InputField
              id="postalCountry"
              name="postalCountry"
              placeholder={'Zemlja'}
              onChange={onChange}
              value={state.postalCountry}
            />
          </Col>
          <Col md={4}>
            <div className="title-block-form">Kontakti</div>
            <InputField
              id="phone1"
              name="phone1"
              placeholder={'Telefon 1'}
              onChange={onChange}
              value={state.phone1}
            />
            <InputField
              id="phone2"
              name="phone2"
              placeholder={'Telefon 2'}
              onChange={onChange}
              value={state.phone2}
            />
            <InputField
              id="phone3"
              name="phone3"
              placeholder={'Telefon 3'}
              onChange={onChange}
              value={state.phone3}
            />
            <InputField
              id="email1"
              name="email1"
              placeholder={'E-mail 1'}
              onChange={onChange}
              value={state.email1}
              type={'email'}
              inputPlaceholder={'email1@email.com'}
            />
            <InputField
              id="email2"
              name="email2"
              placeholder={'E-mail 2'}
              onChange={onChange}
              value={state.email2}
              type={'email'}
              inputPlaceholder={'email2@email.com'}
              required
              error={errors}
              errorsHandler={errorsHandler}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ThirdSection;
